import { v4 as uuid } from 'uuid';

export const getUniqueQueryKey = (key?: string) => {
    return key ? `${key}-${uuid()}` : uuid();
};

/** @example getUniqueQueryKeys(['activities']) -> { activities: 'activities-UUID' } */
export function getUniqueQueryKeys<T extends string>(array: T[]) {
    // @ts-ignore
    const keys: Record<T, string> = {};

    for (let key of array) {
        keys[key] = getUniqueQueryKey(key);
    }

    return keys;
}
